import { createAsyncThunk } from '@reduxjs/toolkit';
import { GlobalConfigurationsService } from '../../services/GlobalConfigurationsService';

export const fetchGlobalConfigurations = createAsyncThunk(
  'fetchGlobalConfigurations',
  async () => GlobalConfigurationsService.get().then((result) => result.data),
);
